import Button from '../../../../../shared/components/Button/Button';

interface Props {
  text: string;
  onClick(): void;
  disabled: boolean;
}

export default function CartButton({
  text,
  onClick,
  disabled,
}: Props) {
  return (
    <Button
      text={text}
      className='cart-button'
      radius={3}
      onClick={onClick}
      disabled={disabled}
    />
  );
}
